module.exports = __webpack_public_path__ + "img/hb.b03c39a7.png";